import {Directive, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewContainerRef} from '@angular/core';
import {Store} from '@ngrx/store';
import {isAuthenticated, isGameMaster} from 'gamesis-state';

@Directive({
    selector: '[gm]'
})
export class GameMasterDirective implements OnInit, OnChanges {

    constructor(private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef,
                private store: Store) {
    }

    @Input()
    public gm = true;

    ngOnInit(): void {
        this.render();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.render();
    }

    private render(): void {
        this.store.select(isGameMaster).subscribe((gameMaster: boolean) => {
            this.viewContainer.clear();
            if (gameMaster === this.gm) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        });
    }


}

@Directive({
    selector: '[authenticated]'
})
export class AuthenticatedDirective implements OnInit {

    constructor(private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef,
                private store: Store) {
    }

    ngOnInit() {
        this.store.select(isAuthenticated).subscribe((authenticated: boolean) => {
            this.viewContainer.clear();
            if (authenticated) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            }
        });
    }
}
